<template>
  <div id="app">
    <MglMap ref="map" :accessToken="accessToken" :mapStyle="mapStyle" @load="onMapLoad">
      <div v-if="trip">
        <Step v-if="route"/>
        <Trip v-else />

        <MglMarker 
          v-if="route"
          v-for="(step, idx) in steps"
          :key="step.html_instructions"
          :coordinates="getStepCoordinate(step)"
          color="black" />

          <img id="logo" src="/logo.png" alt="logo" v-if="!route" />
      </div>
    </MglMap>
  </div>
</template>

<script>
import Mapbox from "mapbox-gl";
import { MglMap, MglMarker } from "vue-mapbox";

import Trip from './components/Trip.vue';
import Step from './components/Step.vue';

export default {
  name: 'App',
  components: { MglMap, MglMarker, Trip, Step },
  created() {
    this.mapbox = Mapbox;
  },
  data() {
    return {
      accessToken: 'pk.eyJ1IjoidW5pdGVoZW5yeSIsImEiOiJja3J4YWd3OHUwMG94Mm9ta28xeHVuM3BnIn0.S57OCbpPWZY3E4fRZp1sRA',
      mapStyle: 'mapbox://styles/mapbox/light-v10',
      mapbox: null
    }
  },
  computed: {
    trip() {
      return this.$store.state.trip;
    },
    route() {
      return this.$store.state.route;
    },
    vehicle() {
      return this.$store.state.vehicle;
    },
    steps() {
      if(this.route) {
        return this.route.legs[0].steps;
      }

      return [];
    },
    stepIndex() {
      return this.$store.state.stepIndex;
    }
  },
  methods: {
    onMapLoad() {
      this.$store.dispatch('loadTrip', this.$refs.map);
      this.$store.dispatch('loadModel', this.$refs.map);
    },
    getStepCoordinate(stp) {
      const startLocation = stp.start_location;
      return [ startLocation['lng'], startLocation['lat'] ];
    }
  },
  watch: {
    stepIndex(value) {
      if(value) {
        const startLocation = this.steps[value].start_location;
        this.$refs.map.actions.easeTo({ center: [ startLocation['lng'], startLocation['lat'] ], zoom: 12 });
      } else {
        const startLocation = this.trip.directions.routes[0].legs[0].steps[0].start_location;
        this.$refs.map.actions.easeTo({ center: [ startLocation['lng'], startLocation['lat'] ], duration: 2000, zoom: 7 });
      }
    }
  }
}
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
}

input[type=text],
input[type=datetime-local] {
  width: 100%;
  padding: 9px;
  margin: 5px 0 10px 0;
  font-family: inherit;
}

input[type=datetime-local] {
  padding: 7px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow: hidden;
}

.mgl-map-wrapper {
  width: 100vw;
  height: 100vh;
}

#logo {
  position: absolute;
  right: 5px;
  bottom: 25px;
  background-color: #fff;
  width: 200px;
  border-radius: 6px;
  padding: 5px;
  z-index: 2;
}
</style>
